import styled from 'styled-components';

export const BigTitle = styled.div`
    font-family:'Kanit';
    padding-top: 62px;
    font-weight: 500;
    font-size: 24px;
    color: #212121;
    opacity: 1;
    text-align:center;
   
    @media (max-width: 700px) {
      padding-top: 29px;
    }
`;


export const DivForm = styled.div`
    display: table;
    width: 660px;
    margin-top: 14px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 46px;

    .MuiFormHelperText-root.Mui-error{
      color:#BC0000;
    }

    .MuiFormHelperText-contained{
      margin-left: 5px;
    }

    .activeSpan{
      display: block;
      color:#BC0000;
      font-size: 12px;
      margin-left:3px;
      margin-top:-15px;
      font-family: Open Sans, sans-serif;
    }

    .disableSpan{
      display: none;
    }

    @media (max-width: 700px) {
      .activeSpan{
        display: table;
        color: #BC0000;
        font-size: 12px;
        margin-left: auto;
        margin-right: auto;
        margin-top: -15px;
        font-family: Open Sans,sans-serif;
      }
    }


    .input-AXS{
        width: 93px;
        height: 54px;
        background: #F5F5F5;
        border-radius: 8px;
        border:none;
        outline: none;
        color: #757575;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: 13px;
        position:relative;
        margin-bottom: 30px;
      }
    
      .input-AXS input{
        width: 93px;
        height: 54px;
        background: #F5F5F5;
        border-radius: 8px;
        border:none;
        outline: none;
        color: #757575;
      }

      @media (max-width: 700px){
        .input-AXS{
            width:90px;
        }
        .input-AXS input{
            width:90px;
        }
        width: 100%;

      }

`;
export const GridSelect = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    width:101%;
    justify-content: space-between;

    @media (max-width: 700px){
        display: grid;
        grid-template-columns: auto;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: center;
      }

`
export const DivSelect = styled.div`
    display: inline-table;
    width: 310px;
    background: #F5F5F5;
    border-radius: 8px;
    margin-bottom: 30px;
    font-family: 'Open Sans', sans-serif;
    @media (max-width: 700px){
        width: 344px;

        .MuiAutocomplete-root{
            width: 344px;
            font-family: 'Open Sans', sans-serif;
        }
      }
    .MuiInputBase-input{
      font-family: 'Open Sans', sans-serif;
      }
    .MuiOutlinedInput-notchedOutline{
        border:none;
        font-family: 'Open Sans', sans-serif;
       }
  
       .MuiFormLabel-root-MuiInputLabel-root.Mui-focused{
        color:#757575;
        font-size: 16px;
        font-family: 'Open Sans', sans-serif;
      }
  
       .MuiOutlinedInput-root{
        height: 56px;  
        font-family: 'Open Sans', sans-serif;
      }
  
    .MuiInputLabel-outlined {
      font-family: 'Open Sans', sans-serif;
      z-index: 1;
      transform: translate(14px, 20px) scale(1);
      pointer-events: none;
  }
  .MuiInputLabel-outlined.MuiInputLabel-marginDense {
    transform: translate(14px, 20px) scale(1);
    color:#757575;
    font-family: 'Open Sans', sans-serif;
  }
  .MuiInputLabel-outlined {
    z-index: 1;
    -webkit-transform: translate(14px,20px) scale(1);
    -ms-transform: translate(14px,20px) scale(1);
    transform: translate(14px,20px) scale(1);
    pointer-events: none;
    font-family: 'Open Sans', sans-serif;
  }
  
  .MuiInputLabel-outlined.MuiInputLabel-shrink{
    transform: translate(14px, -6px) scale(0.75);
    font-family: 'Open Sans', sans-serif;
  }
`;

export const DivBoxInput = styled.div`
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    justify-content: space-between;


     @media (max-width: 700px){
        width: 100%;
        display: grid;
        grid-template-columns: auto auto auto;
        grid-gap:20px;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: center;
     }
`;

export const DivInput = styled.div`

`;


 export const TextInfoOne = styled.div`
    font-weight: 400;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #212121;
    margin: 24px 0px 16px 0px;

    @media (max-width: 700px){
        margin-left:auto;
        margin-right:auto;
        width:344px;
        text-align:left;
     }
`;

export const TextInfoTwo = styled.div`
    font-weight: 400;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 19px;
    color: #212121;
    margin-top:15px;
     margin-bottom:15px;
    .purple{
        color: #6C5AF4;
    }

    @media (max-width: 700px){
        margin-left:auto;
        margin-right:auto;
        width:344px;
        text-align:left;
     }
`;

export const TextInfoThree= styled.div`
    font-style: normal;
    font-weight: 400;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 22px;
    color: #212121;
    margin-bottom:30px;
    .purple{
        color: #6C5AF4;
    }

    @media (max-width: 700px){
        margin-left:auto;
        margin-right:auto;
        width:344px;
        text-align:left;
     }

`;

export const DivButton = styled.div`
    @media (max-width: 700px){
      margin-left:auto;
      margin-right:auto;
      margin-bottom:50px;
      width:344px;
    }
    .buttonBack {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #6C5AF4;
        border-radius: 8px;
        color: #6C5AF4;
        @media (max-width: 700px){
          width: 130px;
          height: 49px;
        }
      }

      .buttonBack:hover {background: #FFFFFF}

      .buttonSend {
        font-size: 0.875rem;
        font-weight: 700;
        text-transform: capitalize;
        font-family: 'Open Sans', sans-serif;
        cursor:pointer;
        width: 203px;
        height: 52px;
        background: #6C5AF4;
        border-radius: 8px;
        color: #FFFFFF;
        float:right;

        @media (max-width: 700px){
          width: 130px;
          height: 49px;
          margin-bottom: 80px;
        }
      }

      .buttonSend:hover {background: #6C5AF4;}

 `;
